import React from "react";
import { AskPanel } from "../components/AskPanel";

/**
 * Ask — dedicated full-page chat surface (nav item in the sidebar). Sits
 * inside the DashboardLayout <Outlet /> so it inherits the topbar and paper
 * background.
 */
const Ask = () => {
  return (
    <div className="max-w-3xl mx-auto" style={{ height: "calc(100vh - 140px)" }} data-testid="ask-page">
      <AskPanel variant="full" />
    </div>
  );
};

export default Ask;
